'use client';

import { useTranslations } from 'next-intl';
import { ErrorContent } from '@ordering/components/ErrorContent';

export default function NotFound() {
  const t = useTranslations();

  return <ErrorContent title={t('not_found.title')} description={t('not_found.description')} />;
}
